module.exports = __webpack_public_path__ + "static/img/old-vs-new.077defa3.gif";